import { EventViewData } from 'components/eventView/pages/eventData';

export const Liege2024Event: EventViewData = {
    eventId: 'liege-career-night',
    mapId: 'de2c5cc4-0af0-4f78-a1ee-f54460c33905',
    guideId: '283b4b98-731a-47ac-abd1-616381ffad99',
    mapSettings: {
        standZoom: 0.8
    }
};
